import CircleImageText from "./components/CircleImageText"
export default CircleImageText
